var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import styled, { css } from 'styled-components';
export var Size;
(function (Size) {
    Size["small"] = "small";
    Size["medium"] = "medium";
    Size["large"] = "large";
    Size["wide"] = "wide";
})(Size || (Size = {}));
var modifiers = (_a = {},
    _a[Size.small] = { padding: '7px 24px' },
    _a[Size.medium] = { padding: '12px 24px' },
    _a[Size.large] = { padding: '16px 24px' },
    _a[Size.wide] = { padding: '12px 100px' },
    _a);
export var ButtonStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: 0.04em;\n  border-radius: 3px;\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: 0.04em;\n  border-radius: 3px;\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var size = _a.size;
    return size && modifiers[size].padding;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.button;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.buttonWeight;
});
export var ButtonA = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n"], ["\n  ", "\n  display: inline-block;\n"])), ButtonStyles);
export var Button = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ButtonStyles);
Button.defaultProps = {
    disabled: false,
    size: Size.medium,
};
ButtonA.defaultProps = {
    disabled: false,
    size: Size.medium,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=button.js.map